<template>
  <div class="path-map">
    <l-map @ready="mapReady" class="l-map" ref="leafmap" :options="mapOptions">
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-control-zoom position="topright" v-if="hideScaleBtn" ></l-control-zoom>
<!--      <l-control position="bottomright" class="flickity-container" v-if="hideScaleBtn">-->
<!--        <div >-->
<!--          <div class="milestone-list">-->
<!--            <flickity ref="flickity" class="f-main" :options="flickityOptions">-->
<!--              <div class="f-cell" v-for="(m, mIndex) in allMilestones" :key="mIndex">-->
<!--                <button class="nav-btn" @click="flickitySelect(mIndex)">-->
<!--                  {{m.name}}<br/>-->
<!--                  <small>{{m.height}} m</small>-->
<!--                </button>-->
<!--              </div>-->
<!--            </flickity>-->
<!--          </div>-->
<!--        </div>-->
<!--      </l-control>-->
      <l-control position="bottomright">
        <button class="btn control-btn" @click="toggleStrokeMethod">
          <img :src="mapColorBtbSvg" alt="地圖切換鍵">
        </button>
      </l-control>
<!--      <l-control position="bottomright" v-if="!hideScaleBtn">-->
<!--        <button class="btn control-btn" @click="mapScaleToggle">-->
<!--          <img :src="mapBtnSvg" alt="地圖縮放鍵">-->
<!--        </button>-->
<!--      </l-control>-->
      <l-control position="bottomright" v-if="!hideSwapBtn">
        <b-button class="control-btn" variant="reverse" @click="mapRouteReverse">
          <Icon name="Swap" size="24" />
        </b-button>
      </l-control>
      <l-control position="topleft" v-if="!hideScaleBtn">
        <b-button variant="map-close" @click="mapScaleToggle">
          <Icon name="close" size="24" />
        </b-button>
      </l-control>
      <l-control position="topleft" v-if="hideScaleBtn && toggleIcon">
        <b-button class="control-btn" @click="mapScaleToggle">
          <img :src="mapBtnSvg" alt="地圖縮放鍵">
        </b-button>
      </l-control>
    </l-map>

    <!-- <div class="outside-nav">
      
    </div> -->

  </div>
</template>

<script>
// import Flickity from 'vue-flickity';
import L from 'leaflet';
import { LMap, LTileLayer, LControl, LControlZoom } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

import MapEnlargeSVG from '@/assets/images/svgs/common/map-enlarge.svg';
import MapReduceSVG from '@/assets/images/svgs/common/map-reduce.svg';
import PenSVG from '@/assets/images/svgs/common/pen.svg';
import PenOffSVG from '@/assets/images/svgs/common/pen-off.svg';
import svgRouteReverse from "@/assets/images/icon/route_reverse.svg";


export default {
  name: 'PathMap',
  props: {
    path: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    milestones: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    journeyContent: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    mapScaleMaximum: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideScaleBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideSwapBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    toggleIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    debug: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      initDraw: false,
      pathReady: false,
      mapApiReady: false,

      mapOptions: {
        zoomControl: false,
      },
      drawDifficulty: true,

      parentReady: false,

      startIcon: null,
      endIcon: null,
      milestoneIcon: null,

      allPath: [],
      // routeLine: null,

      allMilestones: [],
      milestoneMarkers: [],
      selectingMilestoneSerial: -1,

      dataFromJourney: {
        paths: [
          // {
          //   pts: [
          //     {
          //       lat: 0,
          //       lng: 0,
          //     }
          //   ],
          //   difficulty: 0,
          // }
        ],
      },

      mapRenderPaths: [],

      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      flickity: null,
      flickityOptions: {
        cellAlign: 'center',
        // contain: true,
        pageDots: false,
        prevNextButtons: false,

        // any options from Flickity can be used
      },

      imageSrc: {
        svgRouteReverse: svgRouteReverse,
      },
    };
  },
  components: {
    // Flickity,
    LMap,
    LTileLayer,
    LControl,
    LControlZoom,
  },
  watch: {
    path() {
      console.log('path changed.');
    },
    milestones() {
      console.log('milestone changed.');
    },
    selectingMilestoneSerial(v) {
      for (const m of this.milestoneMarkers) {
        if (m.__tempMilestoneSerial === v) {
          m.openPopup();
          return;
        }
      }
    },
  },
  created() {
    this.reloadPathAndMilestone();
  },
  mounted() {
    this.startIcon = L.icon({
      iconUrl: 'https://maps.google.com/mapfiles/kml/paddle/go.png',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
    });

    this.endIcon = L.icon({
      iconUrl: 'https://maps.google.com/mapfiles/kml/paddle/grn-square.png',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
    });

    this.milestoneIcon = L.icon({
      iconUrl: 'https://maps.google.com/mapfiles/kml/paddle/grn-blank.png',
      // iconUrl: 'http://maps.google.com/mapfiles/kml/paddle/ylw-blank.png',
      // iconUrl: 'https://joyhike.s3.ap-northeast-3.amazonaws.com/location.svg',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
    });

    setTimeout(() => {
      this.parentReady = true;
    }, 0);

    // setTimeout(() => {
    //   // console.log(this.$refs.flickity);
    //   this.$refs.flickity.on('select', this.flickityOnSelect);
    // }, 200);

    this.buildDataFromJourney();
  },
  computed: {
    mapBtnSvg() {
      return this.mapScaleMaximum ? MapReduceSVG : MapEnlargeSVG;
    },
    mapColorBtbSvg() {
      return this.drawDifficulty ? PenSVG: PenOffSVG;
    },
  },
  methods: {
    buildDataFromJourney() {
      if (this.journeyContent !== null) {
        this.dataFromJourney.paths.splice(0);
        for (let i=0;i<this.journeyContent.length;i++) {
          const r = this.journeyContent[i];
          if (r.type === 'route') {
            // console.log(r.detail.name);
            const pts = [];
            // let lastHeights = 0;
            // let upSum = 0;
            // let downSum = 0;
            // console.log('方向', r.direction);

            const startMilestone = this.journeyContent.find((m) => {
              return m.type === 'milestone' && m.serial === r.detail.startMilestone;
            });
            const endMilestone = this.journeyContent.find((m) => {
              return m.type === 'milestone' && m.serial === r.detail.endMilestone;
            });
            if (startMilestone === null || endMilestone === null) {
              console.error('找不到起點或終點');
              continue;
            }
            
            pts.push({
              lat: startMilestone.detail.lat,
              lng: startMilestone.detail.lng,
            });
            for (const rpts of r.detail.routepts) {
              pts.push(
                {
                  lat: rpts.lat,
                  lng: rpts.lng,
                }
              );
            }
            pts.push({
              lat: endMilestone.detail.lat,
              lng: endMilestone.detail.lng,
            });
            // lastHeights = this.journeyContent[i-1].detail.height;
            // if (r.direction === 0) {
            //   // console.log(`${i}正向`);
            //   // 正向
            //   pts.push({
            //     lat: this.journeyContent[i-1].detail.lat,
            //     lng: this.journeyContent[i-1].detail.lng,
            //   });
            //   for (const rpts of r.detail.routepts) {
            //     pts.push(
            //       {
            //         lat: rpts.lat,
            //         lng: rpts.lng,
            //       }
            //     );
            //   }
            //   pts.push({
            //     lat: this.journeyContent[i+1].detail.lat,
            //     lng: this.journeyContent[i+1].detail.lng,
            //   });
            //   // for (const rhpts of r.detail.heights) {
            //     // console.log(rhpts);
            //     // const h = rhpts - lastHeights;
            //     // if (h > 0) {
            //     //   upSum += h;
            //     // } else {
            //     //   downSum -= h;
            //     // }
            //     // lastHeights = rhpts;
            //   // }
              
            // } else {
            //   // 逆向
            //   pts.push({
            //     lat: this.journeyContent[i+1].detail.lat,
            //     lng: this.journeyContent[i+1].detail.lng,
            //   });
            //   for (let i=r.detail.routepts.length - 1;i>=0;i--) {
            //     const rpts = r.detail.routepts[i];
            //     pts.push(
            //       {
            //         lat: rpts.lat,
            //         lng: rpts.lng,
            //       }
            //     );
            //   }
            //   pts.push({
            //     lat: this.journeyContent[i-1].detail.lat,
            //     lng: this.journeyContent[i-1].detail.lng,
            //   });
            //   // for (let i=r.detail.heights.length - 1;i>=0;i--) {
            //     // const rhpts = r.detail.heights[i];
            //     // const h = rhpts - lastHeights;
            //     // if (h > 0) {
            //     //   upSum += h;
            //     // } else {
            //     //   downSum -= h;
            //     // }
            //     // lastHeights = rhpts;
            //   // }
            // }
            
            // const h = this.journeyContent[i+1].detail.height - lastHeights;
            // if (h > 0) {
            //   upSum += h;
            // } else {
            //   downSum -= h;
            // }
            
            const milestoneHeightDis = Math.abs(this.journeyContent[i+1].detail.height - this.journeyContent[i-1].detail.height);

            const distance = r.detail.distance / 1000;
            // const costTime = (r.direction === 0?r.detail.consuming:r.detail.returnConsuming) / 60;
            // console.log('總升', upSum, '總降', downSum);
            // const difficulty = (upSum + downSum) / distance;
            const difficulty = (milestoneHeightDis) / distance;
            // console.log(difficulty);
            // const difficulty = (1.8 * costTime) + (0.3 * distance) + (10 * upSum / 1000) + (0.6 * downSum / 1000);
            this.dataFromJourney.paths.push({
              pts: pts,
              difficulty,
              milestoneHeightDis,
            });
          }
        }
      }
    },
    reloadMilestone() {
      this.allMilestones.splice(0, this.allMilestones.length);
      this.allMilestones = [...new Set(this.milestones)];
      // this.milestones.map((item) => {
      //   const found = this.allMilestones.filter((m) => {
      //     return m.serial === item.serial;
      //   });
      //   if (found.length === 0) {
      //     this.allMilestones.push(item);
      //   }
      // });
    },
    reloadPath() {
      this.allPath.splice(0, this.allPath.length);
      this.path.forEach(({ lat, lng }) => {
        this.allPath.push({ lat, lng });
      });
      // 需要新創常數儲存時 map > foreach, 使用原本就存於data的數值 foreach > map
      // this.path.map(item => {
      //   this.allPath.push({
      //     lat: item.lat,
      //     lng: item.lng
      //   });
      // });
    },
    reloadPathAndMilestone() {
      this.reloadMilestone();
      this.reloadPath();
      this.pathReady = true;
      this.tryInitDraw();
    },
    tryInitDraw() {
      if (this.pathReady && this.mapApiReady && !this.initDraw) {
        this.initDraw = true;
        this.autoFitMap();
        this.showPathOnMap();
      }
    },
    mapReady() {
      const mapObject = this.$refs.leafmap.mapObject;
      this.mapApiReady = true;
      // const startPos = [this.route.start.lat, this.route.start.lng];
      // const endPos = [this.route.end.lat, this.route.end.lng];
      // this.__reloadPathAndMilestone();
      // this.autoFitMap();
      // this.showPathOnMap();
      // L.marker(startPos, {icon: this.startIcon}).addTo(mapObject);
      // L.marker(endPos, {icon: this.endIcon}).addTo(mapObject);
      mapObject.on('click', this.mapClicked);
      this.tryInitDraw();
    },
    autoFitMap: function(){
      const leafBounds = L.latLngBounds();
      for (const m of this.milestones) {
        leafBounds.extend(L.latLng(m.lat, m.lng));
      }
      // for(const m of this.allPath){
      //   leafBounds.extend(L.latLng(m.lat, m.lng));
      // }
      // this.allPath.forEach(item => {
      //   leafBounds.extend(L.latLng(item.lat, item.lng));
      // });
      // console.log(this.allPath);
      this.$refs.leafmap.mapObject.fitBounds(leafBounds);
    },
    mapClicked(evt) {
      console.log({
        lat: evt.latlng.lat,
        lng: evt.latlng.lng
      });
    },
    showPathOnMap() {
      // if (this.routeLine !== null) {
      //   this.routeLine.remove();
      // }
      // let tempLatlngs = [];
      // for (const p of this.allPath) {
      //   tempLatlngs.push([p.lat, p.lng]);
      // }
      // this.routeLine = L.polyline(tempLatlngs, {color: 'blue'});
      // this.routeLine.addTo(this.$refs.leafmap.mapObject);
      // this.routeLine 僅此用到

      const tempLatlngs = this.allPath.map(item => [item.lat, item.lng]);
      const routeLine = L.polyline(tempLatlngs, { 
        color: 'blue',
        opacity: 0.5,
      });
      routeLine.addTo(this.$refs.leafmap.mapObject);

      this.mapRenderPaths.map((p) => {
        p.remove();
      });
      this.mapRenderPaths.splice(0);
      for (let i = this.dataFromJourney.paths.length - 1; i>=0;i--) {
        const p = this.dataFromJourney.paths[i];
        // console.log(p);
        const pts = p.pts.map(item => [item.lat, item.lng]);
        // const difficultyRank = p.difficulty >= 12?3:p.difficulty >= 6?2:1;
        // const difficultyRank = p.difficulty >= 25?3:p.difficulty >= 12?2:1;
        const difficultyRank = p.difficulty >= 265?3:p.difficulty >= 175?2:1;
        const lineWeight = (this.drawDifficulty&&difficultyRank===3)?6:3;
        const colorAry = ['', 'blue', 'yellow', 'red'];
        const routeLine = L.polyline(pts, {
          color: this.drawDifficulty?colorAry[difficultyRank]:'blue',
          opacity: 1,
          // weight: 3,
          weight: lineWeight,
        });
        routeLine.__r = p;
        // console.log(routeLine.__r.difficulty);
        // routeLine.addTo(this.$refs.leafmap.mapObject).bindPopup(routeLine.__r.difficulty.toFixed(2));
        routeLine.addTo(this.$refs.leafmap.mapObject).bindPopup(`高低差 ${p.milestoneHeightDis} m`);
        this.mapRenderPaths.push(routeLine);
      }

      // if (this.milestoneMarkers.length > 0) {
      //   this.milestoneMarkers.map(item => {
      //     item.remove();
      //   });
      //   this.milestoneMarkers.splice(0, this.milestoneMarkers.length);
      // }
      this.milestoneMarkers.splice(0, this.milestoneMarkers.length);

      // for (const m of this.allMilestones) {
      //   const tempMarker = L.marker([m.lat, m.lng], {
      //     icon: this.milestoneIcon,
      //     draggable: false,
      //     title: m.name,
      //   });
      //   tempMarker.addTo(this.$refs.leafmap.mapObject).bindPopup(m.name);
      //   // tempMarker.on('click', item => {
      //   //   console.log(item);
      //   // });
      //   tempMarker.__tempMilestoneSerial = m.serial;
      //   this.milestoneMarkers.push(tempMarker);
      // }
      this.milestoneMarkers = this.allMilestones.map(item => {
        const tempMarker = L.marker([item.lat, item.lng], {
          icon: this.milestoneIcon,
          draggable: false,
          title: item.name,
        });
        tempMarker.__tempMilestoneSerial = item.serial;
        tempMarker.addTo(this.$refs.leafmap.mapObject).bindPopup(`<div class="text-center">${item.name}<br/>${item.height} m</div>`).on('click', () => {
          this.milestoneMarkerClicked(tempMarker.__tempMilestoneSerial);
        });
        return tempMarker;
      });
    },
    milestoneMarkerClicked(serial) {
      const index = this.allMilestones.findIndex(item => item.serial === serial);
      if (index !== -1) {
        this.$refs.flickity.select(index);
        this.selectingMilestoneSerial = serial;
      }
    },
    flickitySelect(index) {
      this.$refs.flickity.select(index);
      console.log(this.$refs.flickity.selectedIndex())
    },
    flickityOnSelect(index) {
      this.selectingMilestoneSerial = this.milestones[index].serial;
    },
    mapSizeChanged() {
      this.$refs.leafmap.mapObject.invalidateSize();
      // this.$refs.flickity.resize();
    },
    toggleStrokeMethod() {
      this.drawDifficulty = !this.drawDifficulty;
      this.showPathOnMap();
    },
    mapScaleToggle() {
      this.$emit('toggle-map-scale');
    },
    mapRouteReverse() {
      this.$emit('reverse-map-route');
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/basic";
  .path-map {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .l-map {
    width: 100%;
    height: 100%;
  }

  .m-list {
    margin-left: -10px;
    margin-bottom: -10px;
    padding: 15px 15px 24px;
    background-color: #fff6;
  }

  .f-main {

  }

  .f-cell {
    padding: 5px;
  }

  .flickity-container {
    width: 100%;
    padding: .5rem .5rem 1rem;
    background-color: #fff6;
    margin: 0 !important;
    margin-bottom: -1rem !important;
  }

  .milestone-list {
    width: 100%;
    margin: 0 !important;
  }

  ::v-deep {
    .leaflet-bottom.leaflet-right {
      left: 0;
      right: 0;
      padding: 0;
    }
  }

  .outside-nav {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 15px 15px 24px;
    background-color: #fff6;
    z-index: 400;
  }

  .nav-btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    font-size: 1rem;
    line-height: 1.5;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    font-size: .875rem;
    border-radius: 1.25rem;
    padding: 0.5rem 1.25rem;
    background-color: #eee;
    color: #333;
    border: none;
  }

  .nav-btn:hover {

  }

  .nav-btn:active {

  }

  .nav-btn:focus {

  }

  .is-selected .nav-btn {
    background-color: #666;
    color: #fff;
  }

  .btn.control-btn {
    background: $color-white;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    img {
      width: 28px;
      height: 28px;
      object-fit: cover;
    }
  }
  .btn.btn-map-close {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    border-radius: 100px;
    color: $color-white;
    background: $color-black-800;
    padding: 0;
  }
  .btn.btn-reverse {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: $color-black;
    background: $color-white;
    padding: 0;
  }
</style>
